import {
  ref,
  computed,
  reactive,
  getCurrentInstance,
  watch,
  onBeforeMount,
} from '@vue/composition-api'
import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'

export default function useImageMultipleUpload(props) {
  const {
    openErrorModal,
    openSuccessModal,
    openWarningModal,
    openDefaultErrorModal,
  } = useValidationModal()

  const vm = getCurrentInstance().proxy

  const imageList = ref([])
  const isFileImage = file => file && file.type.split('/')[0] === 'image'
  
  const onChangeImage = e => {
    const filesOBJ = [...e.target.files]
    const uploadImage = []

    const maxLength = props.imageDataList.length + filesOBJ.length

    if (filesOBJ.length > 0 && maxLength <= 10) {
      filesOBJ.forEach(o => {
        if (!isFileImage(o)) {
          openWarningModal(
            'อัปโหลดได้เฉพาะไฟล์รูปภาพ',
            `${o.name} นามสกุลไฟล์ไม่ถูกต้อง`,
            null,
            null,
            null,
            'ปิด',
            false,
            true,
          )
          return
        }

        uploadImage.push({
          image_id: 0,
          file: o,
          image_url: URL.createObjectURL(o),
        })
      })
      vm.$emit('onUpload', uploadImage)
    } else {
      openWarningModal(
        'อัปโหลดรูปได้สูงสุด 10 ไฟล์',
        null,
        null,
        null,
        null,
        'ปิด',
        false,
        true,
      )
    }
  }

  const onUpload = () => {
    vm.$refs.refInputMulti.click()
  }

  const onRemoveImage = fileIndex => {
    vm.$emit('onDelete', fileIndex)
  }

  const fetchImageData = () => {
    imageList.value = props.imageDataList
  }

  const openImage = url => {
    window.open(url)
  }

  onBeforeMount(() => {
    fetchImageData()
  })

  return {
    imageList,
    onUpload,
    onChangeImage,
    openImage,
    onRemoveImage,
  }
}
